module.exports = __webpack_public_path__ + "static/img/4494_phase_function_Paper_PointsHejduk_Prediction.a8abafa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4494_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 3oAx
// module chunks = 0